import { render, staticRenderFns } from "./specialistMemberEdit.vue?vue&type=template&id=9ab741aa&"
import script from "./specialistMemberEdit.vue?vue&type=script&lang=js&"
export * from "./specialistMemberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports